import dynamic from "next/dynamic";
import { useMemo } from "react";
import Loading from "@/components/Loading";
import { useAdultModeQuery, useAuthUserQuery } from "@/hooks";
import config from "@/lib/config";
import { jsx as _jsx } from "react/jsx-runtime";
var Canvas = dynamic(function () {
  return import("@/components/Canvas");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@/components/Canvas")];
    }
  }
});

function getIdKey(user, adultMode) {
  var adultOrVod = adultMode ? "adult" : "vod";

  if (user) {
    return config.canvas.loginTop[adultOrVod];
  } else {
    return config.canvas.top[adultOrVod];
  }
}

export var __N_SSP = true;
export default function Home() {
  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      adultModeLoading = _useAdultModeQuery.loading,
      adultModeData = _useAdultModeQuery.data;

  var adultMode = adultModeData === null || adultModeData === void 0 ? void 0 : adultModeData.adultMode;

  var _useAuthUserQuery = useAuthUserQuery(),
      userLoading = _useAuthUserQuery.loading,
      userData = _useAuthUserQuery.data;

  var user = userData === null || userData === void 0 ? void 0 : userData.user;
  var key = useMemo(function () {
    return getIdKey(user, adultMode);
  }, [adultMode, user]);

  if (adultModeLoading || userLoading) {
    return /*#__PURE__*/_jsx(Loading, {
      fixed: true
    });
  }

  return /*#__PURE__*/_jsx(Canvas, {
    idKey: key
  });
}